import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "registrationOuterContainer d-none" }
const _hoisted_2 = {
  id: "registrationContainer",
  class: "create_account"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "div-loading flyoutLoader",
  style: {"display":"none"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "accountConfirmationOuterContainer d-none" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "accountConfirmationContainer",
    class: "create_account"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "create_account_title" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "create_account_close" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: "/-/media/Feature/EchoPark/Account/EchoparkLogin/icons-menu-close.svg?iar=0&hash=A72D0C4A2849A3EB80563D85FE8E4E3A",
          alt: "Close"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "account_infobox" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "status_icon" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: "/-/media/Project/Sonic/EchoPark/Icons/icons-circle-check.svg?iar=0&hash=5113017CC71ECF6F53D655605B3E8024",
          alt: "Check icon"
        })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "HeadingParkGray-H4" }, "Account created"),
      /*#__PURE__*/_createElementVNode("p", { class: "ParagraphParkGray-BodySM" }, [
        /*#__PURE__*/_createTextVNode(" You can now save favorites "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" Access favorites on any device "),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" Get price alerts  ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("form", {
      action: "",
      role: "form",
      autocomplete: "off"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "form-group-16 submit-btn" }, [
        /*#__PURE__*/_createElementVNode("a", {
          class: "btn btn-primary",
          href: "/used-cars",
          id: "accountCreatedUsedCars"
        }, "Shop all cars")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "form-group-16" }, [
        /*#__PURE__*/_createElementVNode("a", {
          class: "btn btn-secondaryDark",
          href: "/my-account",
          id: "accountCreatedDefualtPageLink"
        }, "View my account")
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sc_rich_text = _resolveComponent("sc-rich-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_sc_rich_text, {
          field: $props.fields.html
        }, null, 8, ["field"])
      ])
    ]),
    _hoisted_4
  ]))
}